import { useState } from "react";
import { initials } from "../../lib/format";

/* ------------------------------- AVATAR ------------------------------- */
export function Avatar({ name, src, size = "", square = false }) {
  const cls = `avatar${size === "lg" ? " avatar-lg" : ""}${square ? " avatar-sq" : ""}`;

  // Parte del catálogo heredado apunta a imágenes de terceros que ya no
  // existen. Sin esto la fila muestra el icono de imagen rota del navegador;
  // con esto cae en las iniciales, igual que un registro sin imagen.
  const [fallo, setFallo] = useState(false);

  /*
   * Si la fila se reutiliza para otro registro, la imagen nueva merece su
   * propio intento.
   *
   * Se ajusta DURANTE el render comparando contra el `src` anterior, no en un
   * `useEffect`: con el efecto, React pintaba primero las iniciales del
   * registro nuevo con el fallo del anterior y volvía a renderizar. Es el
   * patrón que la propia documentación recomienda para "reiniciar estado
   * cuando cambia una prop".
   */
  const [srcPrevio, setSrcPrevio] = useState(src);

  if (src !== srcPrevio) {
    setSrcPrevio(src);
    setFallo(false);
  }

  if (src && !fallo) {
    return (
      <img
        className={cls}
        src={src}
        alt=""
        loading="lazy"
        onError={() => setFallo(true)}
      />
    );
  }

  return <span className={cls}>{initials(name)}</span>;
}


/** Celda de identidad: avatar + nombre + línea secundaria. */
export function Identity({ name, sub, src, square = false }) {
  return (
    <div className="identity">
      <Avatar name={name} src={src} square={square} />
      <div style={{ minWidth: 0 }}>
        {/* El título recupera lo que el recorte se lleva: en columnas
            acotadas, el nombre completo solo se ve al pasar el ratón. */}
        <div
          className="identity-main truncate"
          title={typeof name === "string" ? name : undefined}
        >
          {name || "—"}
        </div>
        {sub && (
          <div
            className="identity-sub truncate"
            title={typeof sub === "string" ? sub : undefined}
          >
            {sub}
          </div>
        )}
      </div>
    </div>
  );
}
